import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Popover, Table } from '../../common/UIComponents';
import { momentTime } from '../../helpers/date_functions';

const BillingRemarksTable = ({ data, timeZoneId }) => {
  const columns = [
    {
      title: 'S.NO',
      key: 'sno',
      align: 'center',
      width: '10%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Remarks By',
      dataIndex: 'current_user_name',
      key: 'current_user_name',
      width: '20%',
      render: (text) => {
        if (!text) return 'N/A';
        return typeof text === 'object' ? JSON.stringify(text) : String(text);
      },
    },
    {
      title: 'Reasons/Remarks',
      dataIndex: 'remark',
      key: 'remark',
      width: '45%',
      render: (text) => {
        if (!text) return 'N/A';
        const stringText = typeof text === 'object' ? JSON.stringify(text) : String(text);
        const maxLength = 90;
        if (stringText.length > maxLength) {
          const truncatedText = `${stringText.substring(0, maxLength)}...`;
          return (
            <Popover
              content={<div style={{ maxWidth: 300, wordBreak: 'break-all' }}>{stringText}</div>}
              title="Remark"
              trigger="hover"
              getPopupContainer={() => document.body}
            >
              <span style={{ cursor: 'pointer' }}>
                {truncatedText}
              </span>
            </Popover>
          );
        }
        return <span>{stringText}</span>;
      },
    },
    {
      title: 'Time',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '25%',
      render: (text) => {
        if (!text) return 'N/A';
        const dateStr = typeof text === 'object' ? (text.$date || JSON.stringify(text)) : String(text);
        const formatted = momentTime('MMM Do YYYY hh:mm A', dateStr, timeZoneId);
        return formatted || 'N/A';
      },
    },
  ];

  return (
    <div id="billing-remarks-table-container" style={{ maxHeight: '600px', overflowY: 'auto', position: 'relative' }}>
      <Table
        dataSource={Array.isArray(data) ? data : []}
        columns={columns}
        rowKey={(record, index) => record?.id || record?._id || index}
        pagination={false}
        size="small"
        bordered
      />
    </div>
  );
};

BillingRemarksTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default BillingRemarksTable;
